<template>
    <Head>
        <title>Comisiones</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-comisiones.png');">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-7">
            <h1 class="hero-encabezado">Comisiones</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="bloque-general">
      <div class="container">

        <div class="row" v-if="comisiones_especiales.length > 0">
          <div class="col-12">
            <h2 class="encabezado-separador"><span>Comisiones especiales</span></h2>
          </div>
        </div>
        <div class="row">

          <div v-for="(item, index) in comisiones_especiales" :key="index" class="col-md-6 col-lg-4">
            <div class="tarjeta-comision-wrapper">
              <div class="tarjeta-comision">
                <div class="tarjeta-comision__encabezado">
                  <img class="comision-icono" loading="lazy" width="" height="" :src="'/img/icono-hexagono-'+item.icono+'.svg'" alt="">
                  <div class="comision-encabezado">{{ item.nombre }}</div>
                </div>
                <div class="tarjeta-comision__info">
                  <div class="comision-info-item">
                    <div class="comision-cargo">Presidente</div>
                    <div class="comision-encargado">{{ item.presidente }}</div>
                  </div>
                  <div class="comision-info-item">
                    <div class="comision-cargo">Secretario</div>
                    <div class="comision-encargado">{{ item.secretario }}</div>
                  </div>
                  <div class="comision-info-item">
                    <div class="comision-cargo">Vocal</div>
                    <div class="comision-encargado">{{ item.vocal }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-12">
            <h2 class="encabezado-separador"><span>Comisiones permanentes</span></h2>
          </div>
        </div>
        <div class="row">

          <div v-for="(item, index) in comisiones" :key="index" class="col-md-6 col-lg-4">
            <div class="tarjeta-comision-wrapper">
              <div class="tarjeta-comision">
                <div class="tarjeta-comision__encabezado">
                  <img class="comision-icono" loading="lazy" width="" height="" :src="'/img/icono-hexagono-'+item.icono+'.svg'" alt="">
                  <div class="comision-encabezado">{{ item.nombre }}</div>
                </div>
                <div class="tarjeta-comision__info">
                  <div class="comision-info-item">
                    <div class="comision-cargo">Presidente</div>
                    <div class="comision-encargado">{{ item.presidente }}</div>
                  </div>
                  <div class="comision-info-item">
                    <div class="comision-cargo">Secretario</div>
                    <div class="comision-encargado">{{ item.secretario }}</div>
                  </div>
                  <div class="comision-info-item">
                    <div class="comision-cargo">Vocal</div>
                    <div class="comision-encargado">{{ item.vocal }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>
<script>
export default {
    props:{
        comisiones: Object,
        comisiones_especiales: Object,
    },
    methods: {

        romanize (num) {
            if (isNaN(num))
                return '';
            var digits = String(+num).split(""),
                key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
                    "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
                    "","I","II","III","IV","V","VI","VII","VIII","IX"],
                roman = "",
                i = 3;
            while (i--)
                roman = (key[+digits.pop() + (i * 10)] || "") + roman;
            return Array(+digits.join("") + 1).join("M") + roman;
        }
    }
}
</script>
<style scoped>

</style>
